'use strict';
/* eslint no-console: 0 */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = require('_');

var _typeHelpers = require('event-tracking-tools/utils/typeHelpers');

var _Immutable = require('Immutable');

var _utils = require('react-utils/utils');

var _constants = require('event-tracking-tools/redux/constants');

var _validateConnectLogger = require('event-tracking-tools/events/validateConnectLogger');

var _convertSchemaToRecords = require('event-tracking-tools/events/convertSchemaToRecords');

var _convertSchemaToRecords2 = _interopRequireDefault(_convertSchemaToRecords);

var _createRecordHash = require('event-tracking-tools/utils/createRecordHash');

var _createRecordHash2 = _interopRequireDefault(_createRecordHash);

var _getConversionRecord = require('event-tracking-tools/utils/getConversionRecord');

var _getConversionRecord2 = _interopRequireDefault(_getConversionRecord);

var _getRecordsAsList = require('event-tracking-tools/utils/getRecordsAsList');

var _getRecordsAsList2 = _interopRequireDefault(_getRecordsAsList);

var _getIsInstanceOfRecords = require('event-tracking-tools/utils/getIsInstanceOfRecords');

var _getIsInstanceOfRecords2 = _interopRequireDefault(_getIsInstanceOfRecords);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _enforceMeta(record) {
  (0, _utils.invariant)(record, 'connectLoggerMiddleware: action.meta[TRACK_EVENT].record must be defined');
}

function _attemptLog(eventLoggers, record, props) {
  // If the record exists as a key, then we'll log it
  var recordKey = (0, _createRecordHash2.default)(record);
  var logFunction = eventLoggers.get(recordKey);
  if ((0, _.isFunction)(logFunction)) {
    logFunction(props);
  } else {
    console.warn('connectLoggerMiddleware: could not find a matching record for attempted event log. Is this event from your schema?');
  }
}

function _tryPayloadConvert(record, conversionRecord, recordList) {
  // allow just-in-time conversion, but it's a little slower.
  var isRecordType = (0, _getIsInstanceOfRecords2.default)(record, recordList);
  if (!isRecordType) {
    var mockSchema = { _: record };
    // This will force whatever the conversion record is, aka the
    // record that is chosen when plain JS is found.
    record = (0, _convertSchemaToRecords2.default)(mockSchema, conversionRecord).get('_');
  }
  return record;
}

exports.default = function (eventsSchema, LoggerClass) {
  var loggerOpts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var handlers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var ForcedRecordClass = arguments[4];

  var logger = void 0;
  var acceptedRecord = void 0;
  try {
    logger = new LoggerClass(loggerOpts);
    acceptedRecord = logger.acceptedRecord;
  } catch (e) {
    /* enforceLogger will handle this */
    console.error('connectLoggerMiddleware:', e.message);
  }
  (0, _validateConnectLogger.enforceLogger)(logger);

  var schemaRecordsMap = (0, _convertSchemaToRecords2.default)(eventsSchema, acceptedRecord, ForcedRecordClass);

  // Uses the record objects as keys. Thanks Immutable!
  var eventLoggers = schemaRecordsMap.reduce(function (newLoggerObj, record) {
    newLoggerObj = newLoggerObj.set((0, _createRecordHash2.default)(record), function (props) {
      return logger.log(record, props);
    });
    return newLoggerObj;
  }, (0, _Immutable.Map)());

  var recordList = (0, _getRecordsAsList2.default)(acceptedRecord);
  var conversionRecord = (0, _getConversionRecord2.default)(recordList, ForcedRecordClass);

  // The actual middleware for redux
  var middleware = function middleware(store) {
    return function (next) {
      return function (action) {
        var prevState = store.getState();
        var result = next(action);

        var actionEventSchema = action.meta && action.meta[_constants.TRACK_EVENT];
        var handler = handlers[action.type];

        // log via action.meta
        if ((0, _typeHelpers.isObject)(actionEventSchema)) {
          var record = actionEventSchema.record;

          _enforceMeta(record);
          record = _tryPayloadConvert(record, conversionRecord, recordList);
          _attemptLog(eventLoggers, record, actionEventSchema.props);

          // log via handler method
        } else if ((0, _.isFunction)(handler)) {
          handler(action, store.getState(), store.dispatch, prevState);

          // log via handler spec
        } else if ((0, _typeHelpers.isObject)(handler)) {
          var _record = handler.record;

          _enforceMeta(_record);
          _record = _tryPayloadConvert(_record, conversionRecord, recordList);
          _attemptLog(eventLoggers, _record, handler.props);
        }

        return result;
      };
    };
  };

  // Just in case we need it. This is a convenience reference.
  middleware.LOGGER = logger;
  return middleware;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/event-tracking-tools/static-1.15/js/redux/connectLoggerMiddleware.js
// module id = 542
// module chunks = 0